export const customerServicePageStyles = {
  page: {
    height: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(180deg, #f7f9fe 0%, #eef2fb 100%)',
  } as const,
  header: {
    paddingTop: 'env(safe-area-inset-top)',
    paddingLeft: 8,
    paddingRight: 8,
    background: 'rgba(247, 249, 254, 0.9)',
    backdropFilter: 'blur(16px)',
    borderBottom: '1px solid rgba(23, 105, 255, 0.08)',
    flexShrink: 0,
  } as const,
  chatCard: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '8px 14px 0',
  } as const,
  intro: {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 6,
    margin: '0 0 8px 2px',
    padding: '5px 10px',
    borderRadius: 999,
    background: 'rgba(255, 255, 255, 0.72)',
    border: '1px solid rgba(226, 235, 252, 0.9)',
    color: '#7d8aa3',
    fontSize: 12,
    fontWeight: 700,
    flexShrink: 0,
  } as const,
  onlineDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#28c76f',
    boxShadow: '0 0 0 3px rgba(40, 199, 111, 0.12)',
    flexShrink: 0,
  } as const,
  loading: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  messageList: {
    flex: 1,
    overflow: 'auto',
    padding: '4px 4px 12px',
    minHeight: 0,
  } as const,
  messageRow: {
    display: 'flex',
    marginBottom: 14,
  } as const,
  messageContent: {
    maxWidth: '78%',
  } as const,
  messageMeta: {
    marginBottom: 5,
    padding: '0 2px',
  } as const,
  messageBubble: {
    padding: '11px 13px',
    borderRadius: 18,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    lineHeight: 1.5,
    boxShadow: '0 10px 24px rgba(76, 93, 135, 0.1)',
  } as const,
  emptyState: {
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
  } as const,
  composerShell: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 10px calc(6px + env(safe-area-inset-bottom))',
    margin: '0 -14px',
    background: 'rgba(255, 255, 255, 0.96)',
    borderTop: '1px solid rgba(23, 105, 255, 0.08)',
    boxShadow: '0 -6px 16px rgba(76, 93, 135, 0.05)',
    flexShrink: 0,
  } as const,
  inputWrap: {
    flex: 1,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 20,
    background: '#f5f7fb',
    border: '1px solid rgba(231, 237, 248, 0.95)',
    padding: '0 13px',
  } as const,
  input: {
    '--font-size': '15px',
    '--color': 'var(--webview-text)',
    '--placeholder-color': '#a4afc1',
    '--text-align': 'left',
  } as const,
  sendButton: {
    minWidth: 62,
    height: 40,
    borderRadius: 999,
    fontWeight: 800,
    flexShrink: 0,
    boxShadow: '0 6px 14px rgba(23, 105, 255, 0.16)',
  } as const,
};
